import { render, staticRenderFns } from "./OrderableSections.vue?vue&type=template&id=2f447c38&"
import script from "./OrderableSections.vue?vue&type=script&lang=ts&"
export * from "./OrderableSections.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports